<template>
  <v-navigation-drawer v-model="model" temporary :scrim="true">
    <v-list nav density="compact">
      <v-list-item :to="'/'" prepend-icon="mdi-view-dashboard" title="Dashboard" />
      <v-list-item :to="'/vehicles'" prepend-icon="mdi-car" title="Vehículos" />

      <!-- NUEVO: Depósitos (visible a admin, capturista y reportes) -->
      <v-list-item
        :to="'/deposits'"
        prepend-icon="mdi-bank-transfer"
        title="Depósitos"
        v-if="can(['admin','capturista','reportes'])"
      />

      <v-list-item :to="'/import'" prepend-icon="mdi-file-upload" title="Importar" v-if="can(['admin','capturista'])" />
      <v-list-item :to="'/reports'" prepend-icon="mdi-chart-line" title="Reportes" v-if="can(['admin','reportes'])" />
      <v-list-item prepend-icon="mdi-format-list-bulleted" title="Plantillas Mantenimiento" :to="{ name:'maintenance-templates' }" />
      <v-list-item v-if="auth.user?.rol === 'admin'" :to="{ name: 'users' }" prepend-icon="mdi-account-cog" title="Usuarios"/>

      <v-divider class="my-2" />
      <v-list-item @click="logout" prepend-icon="mdi-logout" title="Salir" />
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const props = defineProps({ modelValue: Boolean })
const emit = defineEmits(['update:modelValue'])
const model = ref(props.modelValue)
watch(() => props.modelValue, v => model.value = v)
watch(model, v => emit('update:modelValue', v))

const auth = useAuthStore()
const can = (roles) => roles.includes(auth.user?.rol)
const router = useRouter()
const logout = () => {
  auth.logout()
  router.replace({ name: 'login' })
}
</script>
